import { useEffect } from "react";
import { getImage } from "js/utilities";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoginCard from "components/LoginCard";
import { useTranslation } from "react-i18next";
import { removeUser } from "redux/slices/userSlice";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import { removeCsrUser } from "redux/slices/csrUserSlice";
import { removePolicies } from "redux/slices/searchPoliciesSlice";

export default function LandingWLP({
  portal,
  setHideCustomChat,
  connectingToSF,
  setConnectingToSF,
  openChatWindow,
  setOpenChatWindow,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(removeUser());
    dispatch(removeCsrUser());
    dispatch(removePolicies());
  }, []);

  useBreadcrumb([]);
  return (
    <div
      style={{
        background: `linear-gradient(to left, rgba(230,180,110,0.4), rgba(220,220,220,0.6)), url(${getImage(
          "image1.jpg"
        )})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
      className="grid place-content-stretch flex-grow"
    >
      <div className="flex flex-col-reverse justify-center gap-6 my-8 lg:my-16 lg:flex-row lg:justify-around">
        <div className="w-full flex justify-around xl:justify-between self-center xl:px-12 2xl:px-36">
          <div className="flex flex-col gap-6 w-2/3 lg:w-1/3 xl:w-[350px] 2xl:w-[450px]">
            <LoginCard
              loginType={portal}
              setHideCustomChat={setHideCustomChat}
            />
            <div className="ui-card text-center p-4 xl:p-6">
              <h2>{t("UnAuthLandingPage-noAccount-WLP")}</h2>
              <p className="text-sm mb-6">
                {t("UnAuthLandingPage-CustomerSignUpSubtitle-WLP")}
              </p>
              <div className="text-left mb-6"></div>
              <Link
                to="/register"
                className="ui-btn-primary min-w-[144px] mx-auto"
              >
                {t("CustomerSignUp-button")}
              </Link>
            </div>
          </div>

          <div className="hidden lg:block max-w-lg">
            <h2 className="text-3xl lg:text-5xl text-center lg:text-left">
              {t("UnAuthLandingPage-customerTitle-WLP")}
            </h2>
          </div>
        </div>
        <h2 className="block lg:hidden text-3xl lg:text-5xl text-center lg:text-left">
          {t("UnAuthLandingPage-customerTitle-WLP")}
        </h2>
      </div>
    </div>
  );
}
